import { createTheme } from "@mui/material/styles"
import { BankEssential } from "./store/actions/bank"
import { CorporateEssential } from "./store/actions/corporates"
import { getBestContrastColor } from "./utils/contrast-color"

export const getCustomTheme = (
	entity?: CorporateEssential | BankEssential | undefined
) => {
	const primaryColor = entity?.primaryColor ?? "#38719d"
	const secondaryColor = entity?.secondaryColor ?? "#b62377"

	// Crea il tema dinamicamente usando i colori da Redux
	const theme = createTheme({
		palette: {
			mode: "light",
			primary: {
				main: primaryColor,
				contrastText: getBestContrastColor(primaryColor),
			},
			secondary: {
				main: secondaryColor,
				contrastText: getBestContrastColor(secondaryColor),
			},
		},
		components: {
			MuiButton: {
				styleOverrides: {
					startIcon: {
						marginRight: 0,
					},
				},
			},
			MuiCircularProgress: {
				styleOverrides: {
					root: {
						color: secondaryColor,
					},
				},
			},
			MuiLink: {
				styleOverrides: {
					root: {
						"&[disabled]": {
							color: "grey",
							opacity: 0.5,
						},
					},
				},
			},
			MuiTooltip: {
				styleOverrides: {
					tooltip: {
						backgroundColor: primaryColor,
						fontSize: "14px",
					},
					arrow: {
						color: primaryColor,
					},
				},
			},
			MuiTextField: {
				variants: [
					{
						props: { variant: "outlined" },
						style: {
							"> input": {
								backgroundColor: "#e0f7fa",
							},
							"> input:disabled": {
								backgroundColor: "#D1D1D1",
							},
							":hover": {
								".MuiOutlinedInput-notchedOutline": {
									borderColor: primaryColor + " !important",
								},
							},
						},
					},
				],
			},
			MuiOutlinedInput: {
				styleOverrides: {
					root: {
						backgroundColor: "#e0f7fa",
						"&.Mui-disabled": {
							backgroundColor: "#D1D1D1",
						},
					},
				},
			},
			MuiSnackbar: {
				styleOverrides: {
					root: {
						backgroundColor: "#d32f2f",
					},
				},
			},
			MuiAlert: {
				styleOverrides: {
					filledError: {
						backgroundColor: "#d32f2f",
					},
					filledSuccess: {
						backgroundColor: "#388e3c",
					},
					filledWarning: {
						backgroundColor: "#fbc02d",
					},
				},
			},
		},
	})

	return theme
}
